<template>
  <v-text-field
    v-model="cep"
    :label="$t('CEP')"
    v-mask="'##.###-###'"
    name="cep"
    @blur="buscaCep()"
    :loading="loadingCep"
    class="
      input-style
      font-size-input
      text-light-input
      placeholder-light
      input-icon
    "
    dense
    flat
    filled
    solo
  />
</template>

<script>
import DataService from "@/services/ComumDataService";
import {
  cachedCidades,
  isCachedCidadesValid,
  loadCachedCidades,
} from "@/services/cacheCidades";

export default {
  name: "BuscaCep",

  props: {
    cepProp: { type: String, required: true },
    carregarCidades: { type: Boolean, required: false, default: true },
  },

  mounted() {
    this.cep = this.cepProp;

    if (this.carregarCidades) {
      this.getCidades();
    }
  },

  data() {
    return {
      cidades: [],
      cep: "",
      loadingCep: false,
      loadingCidades: false,
    };
  },

  watch: {
    cepProp: function (val) {
      this.cep = val;
    },

    cep: function (val) {
      this.$emit("cep", val);
    },
  },

  methods: {
    buscaCep() {
      if (this.cep.length >= 8) {
        this.loadingCep = true;
        DataService.buscaCep(this.limpaMascara(this.cep))
          .then((response) => {
            console.log("buscaCep", response.data);
            // DataService.findCidade({
            //   cidade: response.data.localidade,
            //   uf: response.data.uf,
            // }).then((cidade) => {
            this.$emit("cidade", response.data.localidade);
            this.$emit("uf", response.data.uf);
            this.$emit("logradouro", response.data.logradouro);
            this.$emit("bairro", response.data.bairro);

            this.$emit("endereco", {
              cidade: response.data.localidade,
              uf: response.data.uf,
              logradouro: response.data.logradouro,
              bairro: response.data.bairro,
            });
            // });
          })
          .finally(() => {
            this.loadingCep = false;
          });
      }
    },

    getCidades() {
      if (isCachedCidadesValid()) {
        this.$emit("cidades", cachedCidades);
        return;
      }
      this.setLoadingCidades(true);
      loadCachedCidades(() => DataService.getCidades())
        .then((cidades) => {
          this.cidades = cidades;
          this.$emit("cidades", cidades);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.setLoadingCidades(false);
        });
    },
    setLoadingCidades(value) {
      this.loadingCidades = value;
      this.$emit("loading-cidades", value);
    },
  },
};
</script>

<style></style>
